import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, FlexSpan } from "../../../../ui";
import { FormatBlock } from "./FormatBlock";
import { SupplyBlock } from "./SupplyBlock";
import { ConsumptionBlock } from "./ConsumptionBlock";
import { PricesBlock } from "./PricesBlock";
export const PointDetails = ({ data }) => {
    return (_jsx(Flex, { column: true, height: "100%", children: _jsxs(FlexSpan, { flexGrow: 1, m: "1.25rem 0", overflow: "auto", p: "0 4px", children: [_jsx(FormatBlock, { data: data }), _jsx(SupplyBlock, { data: data }), _jsx(ConsumptionBlock, { data: data }), _jsx(PricesBlock, { data: data })] }) }));
};
